export async function genCode(api, rCode) {
  //인증번호생성(4자리)
  const numbers = '0123456789';
  const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  let code;
  let rtnCode;

  // 앞의 두 자리는 숫자로 선택
  code = numbers.charAt(Math.floor(Math.random() * numbers.length)) +
    numbers.charAt(Math.floor(Math.random() * numbers.length));

  // 뒤의 두 자리는 영어로 선택
  code += characters.charAt(Math.floor(Math.random() * characters.length)) +
    characters.charAt(Math.floor(Math.random() * characters.length));


  rtnCode = rCode + code;

  return rtnCode;
}

export async function generateCouponCode(api, cpToday, cpQty) {
  const MAX_RETRY = 1000;
  const CODE_LENGTH = 8;
  const characters = '0123456789';
  
  // 쿠폰 코드 생성 함수
  const generateCode = () => {
    return Array.from({ length: CODE_LENGTH }, () => 
      characters[Math.floor(Math.random() * characters.length)]
    ).join('');
  };

  // 메인 로직
  for (let attempt = 1; attempt <= MAX_RETRY; attempt++) {
    const randomPart = generateCode();
    const cpCode = cpToday + randomPart;

    // 중복 체크
    const checkDubCoupon = await api("/api/checkDubCoupon", { param: [cpCode] });

    if (checkDubCoupon.length === 0) {
      // 중복 없을 경우 저장
      const result = await api("/api/ins_coupon_qty", {param: [cpCode, cpQty]});
      
      return result.affectedRows > 0 ? cpCode : (alert("저장 오류 발생"), false);
    }
  }
  return "noCpCode";
}
